<template>
  <div id="app">
    <Loader v-show="$store.state.loader"></Loader>
    <div class="app-cont" v-if="$route.meta.full">
      <router-view :key="$route.fullPath"/>
    </div>
    <div class="app-cont app-cont-pc" v-if="(! $route.meta.full) && $store.state.view == 'pc'">
      <Frame>
        <keep-alive :include="tagsList">
          <router-view :key="$route.fullPath"/>
        </keep-alive>
      </Frame>
    </div>
    <div class="app-cont app-cont-wap" v-if="(! $route.meta.full) && $store.state.view == 'wap'">
      <WapFrame>
        <router-view :key="$route.fullPath"/>
      </WapFrame>
    </div>
  </div>
</template>

<script>
import Loader from './components/Loader'
import Frame from '@/components/Frame'
import WapFrame from '@/components/WapFrame'
export default {
  name: 'App',
  components: {
    Loader,
    Frame,
    WapFrame,
  },
  created () {
    
  },
  mounted () {
    const vm = this;
    function getStyle(obj,attr){ 
      if(obj.currentStyle){ 
        return obj.currentStyle[attr]; 
      } else { 
        return document.defaultView.getComputedStyle(obj,null)[attr]; 
      } 
    }

    // 获得窗口高度
    function getTableHeight () {
      // 获得列表高度
      let listHeight = document.body.clientHeight - 40 - 20;
      vm.$store.commit('updateListHeight', listHeight);
      // 设置表格高度
      let headerHeight = 0;
      let footerHeight = 0;
      for(let dom of document.querySelectorAll('.page-list-form')){
        headerHeight += dom.offsetHeight + parseFloat(getStyle(dom, 'marginTop')) +  parseFloat(getStyle(dom, 'marginBottom'))
      }
      for(let dom of document.querySelectorAll('.flex-list-footer')){
        headerHeight += dom.offsetHeight + parseFloat(getStyle(dom, 'marginTop')) +  parseFloat(getStyle(dom, 'marginBottom'))
      }
      let tableHeight = listHeight - headerHeight - footerHeight - 10;
      vm.$store.commit('updateTableHeight', tableHeight)
      vm.$store.commit('updateView', document.body.clientWidth > 580)
    }
    // 监听窗口变化
    window.addEventListener('resize', this.$utils.throttle(() => {
      getTableHeight()
    }, 1000), false)
    // 初始化高度
    getTableHeight()
  },
  data () {
    return {
      
    }
  },
  computed: {
    tagsList () {
      const list = [];
      this.$store.state.tabs.list.filter(e => {
        if(e.url){
          let arr = e.url.split('/');
          let str = arr[1];
          for(let i = 2; i<arr.length; i++){
            str += arr[i].replace(/( |^)[a-z]/g, (L) => L.toUpperCase())
          }
          list.push(str)
          return str;
        }
      })
      return list
    }
  }
}
</script>

<style lang="scss">
@font-face {
  font-family: 'iconfont';  /* project id 2144218 */
  src: url('//at.alicdn.com/t/font_2144218_x2phe6chi7.eot');
  src: url('//at.alicdn.com/t/font_2144218_x2phe6chi7.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_2144218_x2phe6chi7.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_2144218_x2phe6chi7.woff') format('woff'),
  url('//at.alicdn.com/t/font_2144218_x2phe6chi7.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_2144218_x2phe6chi7.svg#iconfont') format('svg');
}
.iconfont{
  font-family:"iconfont" !important;
  font-style:normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
</style>
